import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { Button, FormControl, Modal, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import api from "../../../../utils/api";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";


export const GrupoCargoEdit = () => {
  const { goBack } = useNav();

  const { id } = useParams();

  const { startLoading, stopLoading, isLoading} = useLoading();
  const { setMensagemSuccess, setMensagemError } = useErrorSuccess();

  const getGrupoCargo = async () => {
    let req = await api.get('ministerio/cargo/grupo/' + id);

    setValue('descricao', req.data.descricao);

    return req.data;
  }

  const {
    register,
    setValue,
    handleSubmit
  } = useForm<{ descricao: string }>({
    defaultValues: {
      descricao: null
    }
  });

  useEffect(() => {
    getGrupoCargo();
  }, [])

  const put = handleSubmit(async (values) => {
    startLoading();
    try {
      await api.put('ministerio/cargo/grupo/' + id, values);
      setMensagemSuccess('Alterado com sucesso!');
      goBack();
    } catch {
      setMensagemError('Erro ao altera grupo!')
    } finally {
      stopLoading();
    }
  })

  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal>
          <FormControl fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained" disabled={isLoading} onClick={put}>Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
